export enum DataVariableType {
  Text = 1,
  Radio = 2,
  Checkbox = 3,
  Date = 4,
  Hidden = 5,
  // Keyboard = 6,
  Email = 7,
  // Locale = 8,
  NumberType = 9,
  Phone = 10
}
